import { createTheme } from '@mui/material/styles';

export const createAppTheme = (darkMode) =>
  createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#c9a962',
      },
      background: {
        default: darkMode ? '#121212' : '#f5f5f5',
        paper: darkMode ? '#1e1e1e' : '#ffffff',
      },
      text: {
        primary: darkMode ? '#ffffff' : '#000000',
        secondary: darkMode ? '#b0b0b0' : '#666666',
      },
      divider: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
      sidebar: {
        bg: '#0d1321',
        text: '#8892a4',
        textActive: '#ffffff',
        hover: 'rgba(255,255,255,0.06)',
        activeBg: 'rgba(25,118,210,0.15)',
        activeBar: '#1976d2',
        sectionTitle: '#4a5568',
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-input': {
              color: darkMode ? '#ffffff' : 'inherit',
            },
            '& .MuiInputLabel-root': {
              color: darkMode ? '#b0b0b0' : 'inherit',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: darkMode ? '#555555' : 'rgba(0, 0, 0, 0.23)',
              },
              '&:hover fieldset': {
                borderColor: darkMode ? '#777777' : 'rgba(0, 0, 0, 0.23)',
              },
            },
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: darkMode ? '#2a2a2a' : '#f8f9fa',
            '& .MuiTableCell-head': {
              fontWeight: 600,
              fontSize: '0.8rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: darkMode ? '#b0b0b0' : '#555555',
              borderBottom: darkMode ? '2px solid rgba(255,255,255,0.12)' : '2px solid #e0e0e0',
            },
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&:nth-of-type(even)': {
              backgroundColor: darkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)',
            },
            '&:hover': {
              backgroundColor: darkMode ? 'rgba(255,255,255,0.06) !important' : 'rgba(25,118,210,0.04) !important',
            },
            '&:last-child td': {
              borderBottom: 0,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '12px 16px',
            fontSize: '0.875rem',
            borderBottom: darkMode ? '1px solid rgba(255,255,255,0.06)' : '1px solid #f0f0f0',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            border: darkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid #e8e8e8',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 6,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            textTransform: 'none',
            borderRadius: 8,
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            },
          },
          outlined: {
            textTransform: 'none',
            borderRadius: 8,
          },
          text: {
            textTransform: 'none',
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 12,
          },
        },
      },
    },
    typography: {
      fontFamily: ['Roboto', 'Noto Sans KR', 'sans-serif'].join(','),
    },
  });
